'use es6';

export const DEFAULT = 'DEFAULT';
export const LOCALIZATION = 'LOCALIZATION';